import { PAGE_SIZES } from "../constants";

export default {
  COMMON: {
    GET_TIMEZONE_LIST: "/timezone",
    GET_TOPIC_LIST: "/topics",
    GET_OPPORTUNITY_CATEGORIES: "/opportunity/categories",
    GET_INDUSTRIES: "/industries",
    GET_TITLES: "/titles",
    GET_CATEGORIES: "/categories",
    GET_NO_OF_EMP: "/no-of-employees",
    GET_STATES: "/states",
    GET_COUNTRIES_LIST: "https://countriesnow.space/api/v0.1/countries",
    GET_STATE_LIST_FROM_COUNTRY:
      "https://countriesnow.space/api/v0.1/countries/states",
  },
  AUTH: {
    LOGIN: "/auth/login",
    LINKEDIN: "/auth/linkedin",
    LOGOUT: "",
    VALIDATE_TOKEN: "",
  },
  DASHBOARD: {
    GET_EVENTS: ({ startDate, endDate }) =>
      `/ambassador-invitations?from=${startDate}&to=${endDate}`,
    GET_NEW_MEETING_COUNT: ({ date }) =>
      `/dashboard/meeting-count?date=${date}`,
    GET_NEW_AMBASSADOR_COUNT: ({ date }) =>
      `/dashboard/ambassador-count?date=${date}`,
    GET_NEW_CLIENT_COUNT: ({ date }) => `/dashboard/client-count?date=${date}`,
    GET_NEW_REVENUE_COUNT: ({ date }) =>
      `/dashboard/revenue-count?date=${date}`,
  },
  CLIENTS: {
    GET_CLIENTS: ({
      selectedPage,
      selectedPageSize,
      searchValue = "",
      isDeleted = false,
    }) => {
      const params = new URLSearchParams();
      params.append("page", String(selectedPage));
      params.append("limit", String(selectedPageSize));
      params.append("search", searchValue);
      if (isDeleted) params.append("isDeleted", "true");
      return `/clients?${params.toString()}`;
    },
    GET_CLIENT_MEETINGS: ({ clientId, selectedPage, selectedPageSize }) =>
      `/ambassador-invitations?clientId=${clientId}&page=${selectedPage}&limit=${selectedPageSize}&withDetails=true`,
    GET_CLIENT_UPCOMING_MEETINGS: ({ clientId, date, token, invitationId }) =>
      `/ambassador-invitations/${token}?clientId=${clientId}&from=${date}&${invitationId}&withDetails=true`,
    GET_CLIENT_INVITATION_STATUS: ({ clientId, selectedDate }) =>
      `/invitation/status?clientId=${clientId}&date=${selectedDate}`,
    GET_CLIENT_PAYMENTS: ({ clientId }) =>
      `/payment/status?clientId=${clientId}`,
    GET_CLIENT_CAMPAIGNS: ({ clientId }) => `/client/${clientId}/campaigns`,
    GET_CLIENT_DETAILS: (id) => `/client/${id}`,
    RESTORE_CLIENT: (clientId) => `/client/${clientId}/restore`,
    DELETE_CLIENT: (id) => `/client/${id}`,
    ADD_CLIENT: `/client`,
    UPDATE_CLIENT: (id) => `/client/${id}`,
    UPLOAD_CLIENT_LOGO: (id) => `/client/upload/logo/${id}`,
    GET_AMBASSADOR_BASED_ON_CRITERIA: (id, limit = 100) =>
      `/clients/ambassadors/${id}?limit=${limit}`,
    SUBMIT_NEW_BUDGET: (id) => `/client/${id}`,
    GET_CLIENT_SELECTED_AMBASSADOR_: (id, selectedOnly) =>
      `/clients/ambassadors/${id}?selectedOnly=${selectedOnly}`,
    GET_MEETING_SUMMARY: (id) => `/client/meeting-data/${id}`,
    GET_MEETING_RECORDINGS: ({
      from = "",
      to = "",
      clientId = "",
      ambassadorId = "",
    }) =>
      `/ambassador-invitations/recordings?withDetails=true&from=${from}&to=${to}&clientId=${clientId}&ambassadorId=${ambassadorId}&limit=100`,
    GET_RECORDING_PARTICIPANTS: ({
      clientId,
      ambassadorId,
    }: {
      clientId?: string;
      ambassadorId?: string;
    }) => {
      if (clientId) {
        return `/ambassador-invitations/participants?clientId=${encodeURIComponent(clientId)}`;
      }
      if (ambassadorId) {
        return `/ambassador-invitations/participants?ambassadorId=${encodeURIComponent(ambassadorId)}`;
      }
      return `/ambassador-invitations/participants`;
    },
    SUBMIT_MIGRATE_VENDOR: `/user/migrate`,
    GET_COMPANY_NAME_WITHOUT_DELEGATE: ({
      selectedPage,
      selectedPageSize,
      searchValue = "",
    }) =>
      `/clients?page=${selectedPage}&limit=${selectedPageSize}&search=${searchValue}&withDelegate=false`,
  },
  AMBASSADORS: {
    GET_AMBASSADORS: ({
      selectedPage,
      selectedPageSize,
      searchValue = "",
      isDeleted = false,
    }) => {
      const params = new URLSearchParams();
      params.append("page", String(selectedPage));
      params.append("limit", String(selectedPageSize));
      params.append("search", searchValue);
      if (isDeleted) params.append("isDeleted", "true");
      return `/ambassadors?${params.toString()}`;
    },
    GET_AMBASSADORS_SIMPLE_LIST: ({
      selectedPage,
      selectedPageSize,
      searchValue = "",
      isDeleted = false,
    }) => {
      const params = new URLSearchParams();
      params.append("page", String(selectedPage));
      params.append("limit", String(selectedPageSize));
      params.append("search", searchValue);
      if (isDeleted) params.append("isDeleted", "true");
      return `/ambassadors/simple-list?${params.toString()}`;
    },
    GET_AMBASSADOR_DETAILS: (id) => `/ambassador/${id}`,
    RESTORE_AMBASSADOR: (ambassadorId) => `/ambassador/${ambassadorId}/restore`,
    DELETE_AMBASSADOR: (id) => `/ambassador/${id}`,
    ADD_AMBASSADOR: `/ambassador`,
    UPDATE_AMBASSADOR: (id) => `/ambassador/${id}`,
    GET_AMBASSADOR_MEETINGS: ({
      selectedPage,
      selectedPageSize,
      ambassadorId,
    }) =>
      `/ambassador-invitations?ambassadorId=${ambassadorId}&page=${selectedPage}&limit=${selectedPageSize}&withDetails=true`,
    GET_AMBASSADOR_PAYMENTS: ({ ambassadorId }) =>
      `/payment/status?ambassadorId=${ambassadorId}`,
    GET_AMBASSADOR_INITIATIVES: (ambassadorId) =>
      `/ambassador-project/ambassador/${ambassadorId}`,
    SUBMIT_PHOTO_UPLOAD: (id) => `/ambassador/upload/photo/${id}`,
  },
  INITIATIVES: {
    GET_INITIATIVES: ({
      selectedPage,
      selectedPageSize,
      ambassadorId = "",
      type = "",
      status = "",
      visibility = "",
      groupByAmbassador = true,
    }) => {
      const params = new URLSearchParams();
      params.append("page", String(selectedPage));
      params.append("limit", String(selectedPageSize));
      if (groupByAmbassador) params.append("groupByAmbassador", "true");
      if (ambassadorId) params.append("ambassadorId", ambassadorId);
      if (type) params.append("type", type);
      if (status === "active") params.append("isActive", "true");
      if (status === "inactive") params.append("isActive", "false");
      if (visibility === "public") params.append("isPublic", "true");
      if (visibility === "private") params.append("isPublic", "false");
      return `/ambassador-projects?${params.toString()}`;
    },
    CREATE: `/ambassador-projects`,
    UPDATE: (id) => `/ambassador-project/${id}`,
    DELETE: (id) => `/ambassador-project/${id}`,
    SUGGEST_OBJECTIVE: `/ambassador-projects/generate-description`,
  },
  CLIENT_AMBASSADOR_INVITE: {
    GET_INVITE_DETAILS: (token, invitationId) =>
      `/invitation/${token}/${invitationId}`,
    SUBMIT_SLOT_SELECTION: (token, invitationId) =>
      `/invitation/${token}/${invitationId}`,
    INVITE_CLIENT_AMBASSADOR: `/invitation`,
    GET_CLIENT_SLOTS_SELECTION: (token, ambassadorInvitationId) =>
      `/ambassador-invitation/${token}/${ambassadorInvitationId}`,
    SUBMIT_AMBASSADOR_SLOT_SELECTION: (token, ambassadorInvitationId) =>
      `/ambassador-invitation/${token}/${ambassadorInvitationId}`,
  },
  INVITATIONS: {
    GET_INVITATION_LIST: (
      selectedPage,
      selectedPageSize,
      searchValue,
      selectedDate,
      status
    ) =>
      `/ambassador-invitations?clientId=${searchValue}&date=${selectedDate}&page=${selectedPage}&limit=${selectedPageSize}&withDetails=true&status=${status}`,
    SUMIT_INVITATION_APPROVAL: (id, type) =>
      `/ambassador-invitation/${id}/${type}`,
    UPDATE_INVITATION: ({ id }) => `/ambassador-invitation/${id}`,
    SUBMIT_MANUAL_MEETING: `/invitation/quick-meeting`,
    ARCHIEVE_MEETING: ({ id }) => `/ambassador-invitation/${id}/archive`,
    POST_TRANSFER_ROLE: `/delegate`,
    GET_ACTIVITY_LOG: ({
      ambassadorId = "",
      clientId = "",
      status = "",
      limit = 10,
      page = 1,
      from = "",
      to = "",
      visitedFilter = "all",
    }) => {
      const visitedQuery =
        visitedFilter === "visited"
          ? "&visited=true"
          : visitedFilter === "unvisited"
            ? "&visited=false"
            : "";
      return `/invitation/audit-log?ambassadorId=${ambassadorId}&clientId=${clientId}&status=${status}&limit=${limit}&page=${page}&from=${from}&to=${to}${visitedQuery}`;
    },
    ACTIVITY_LOG_VISITED: `/invitation/audit-log/visited`,
    REQUEST_RESCHEDULE_SLOTS: (id) => `/ambassador-invitation/${id}/add-time-slot`,
    UPDATE_AVAILABLE_TIME_SLOTS: (id) =>
      `/ambassador-invitation/${id}/available-time-slots`,
    GET_ACTION_LINK: (ambassadorInvitationId) =>
      `/ambassador-invitation/${ambassadorInvitationId}/action-link`,
    SEND_MEETING_REMINDER: (ambassadorInvitationId) =>
      `/ambassador-invitation/${ambassadorInvitationId}/send-meeting-reminder`,
    GET_BLOCKED_DATES: ({ from, to }) =>
      `/projects/blocked-dates?from=${from}&to=${to}`,
  },
  CONNECT: {
    GET_AMBASSADOR_CONNECT_REQUEST: `/users?isVerified=false&role=ambassador`,
    GET_CLIENT_CONNECT_REQUEST: `/users?isVerified=false&role=vendor`,
    APPROVE_USER_REQUEST: (id) => `/user/verified/${id}`,
    REJECT_USER_REQUEST: (id) => `/user/reject/${id}`,
  },
  OPPORTUNITY: {
    SUBMIT_EMAIL_TEMPLATE: `/opportunity`,
    GET_OPPORTUNITIES_LIST: ({ selectedPage, selectedPageSize }) =>
      `/opportunities?page=${selectedPage}&limit=${selectedPageSize}`,
    GET_OPPORTUNITY_RESPONSE_LIST: ({ selectedPage, selectedPageSize }) =>
      `/opportunities/insights?page=${selectedPage}&limit=${selectedPageSize}`,
    GET_OPPORTUNITIES_VENDOR_VIEWERS_LIST: (id) =>
      `/opportunities/view-by/${id}`,
    SUBMIT_CONVERT_TO_VENDOR: (id) => `/opportunity/convert-client/${id}`,
  },
  MARKETPLACE: {
    GET_MARKETPLACE_VENDOR_DATA_BY_ID: (id) =>
      `/marketplace/admin-profile/${id}`,
    GET_MARKETPLACE_CATEGORIES_LIST: "/marketplace/categories",
    GET_MARKETPLACE_LIST: ({
      selectedPage = 1,
      selectedPageSize = PAGE_SIZES[0],
      respondedOnly = false,
    }) =>
      `/marketplace?page=${selectedPage}&limit=${selectedPageSize}&respondedOnly=${respondedOnly}`,
    GET_MARKETPLACE_COUNTRIES_LIST: `/marketplace/countries`,
    SEARCH_KEYWORDS_LIST: (searchValue) =>
      `/marketplace/keywords?search=${searchValue}`,
    SUBMIT_SHARE_PROFILE: (id) => `/marketplace/share-profile/${id}`,
    SUBMIT_FORM: `/marketplace/new`,
    UPDATE_FORM: (id) => `/marketplace/update/${id}`,
    UPLOAD_MARKETPLACE_FILE: (field, id) =>
      `/marketplace/admin-upload/file/${field}/${id}`,
  },
  TYPEFORM: {
    GET_REVIEWS: ({ selectedPage = 1, selectedPageSize = PAGE_SIZES[0] }) =>
      `/typeform/answers?page=${selectedPage}&limit=${selectedPageSize}`,
    GET_ALL_REVIEWS: `/typeform/answers`,
    GET_REVIEW_REPORT_DETAILS: `/typeform/report/generate/all`,
    GET_REVIEW_REPORT_DETAILS_BY_CLIENT: (clientId, ambassadorId) =>
      `/typeform/report/generate/byVendor?clientId=${clientId}&ambassadorId=${ambassadorId}`,
    GET_TYPEFORM_AMBASSADOR_COMPANY_NAME: (id) =>
      `/typeform/ambassadors?clientId=${id}`,
  },
  APP_SETTINGS: {
    GET_SETTINGS: `/app-settings/current`,
    UPDATE_SETTINGS: `/app-settings`,
    FLUSH_REDIS: `/admin/flush-redis`,
  },
  HOLIDAYS: {
    LIST: ({
      year = "",
      type = "",
      countryCode = "US",
      active = "",
      page = 1,
      limit = 200,
    }: {
      year?: string | number;
      type?: string;
      countryCode?: string;
      active?: string | boolean;
      page?: number;
      limit?: number;
    } = {}) => {
      const params = new URLSearchParams();
      params.append("countryCode", countryCode);
      params.append("page", String(page));
      params.append("limit", String(limit));
      if (year !== "" && year != null) params.append("year", String(year));
      if (type) params.append("type", type);
      if (active !== "") params.append("active", String(active));
      return `/holidays?${params.toString()}`;
    },
    CREATE: `/holidays`,
    UPDATE: (holidayId) => `/holidays/${holidayId}`,
    DELETE: (holidayId) => `/holidays/${holidayId}`,
    SYNC: `/holidays/sync`,
  },
  USERS: {
    GET_USERS: ({
      deletedOnly = false,
      search = "",
      selectedPage = 1,
      selectedPageSize,
    }) => {
      const params = new URLSearchParams();
      params.append("page", selectedPage.toString());
      params.append("limit", selectedPageSize.toString());
      if (deletedOnly) params.append("deletedOnly", "true");
      if (search) params.append("search", search);
      return `/users?${params.toString()}`;
    },
    DELETE_USER: (id, hardDelete = false) => {
      const params = new URLSearchParams();
      if (hardDelete) params.append("hardDelete", "true");
      return `/users/${id}${params.toString() ? `?${params.toString()}` : ""}`;
    },
    ARCHIVE_USER: (id) => `/users/${id}`,
    UNARCHIVE_USER: (id) => `/users/${id}/unarchive`,
  },
};
